export default __webpack_public_path__ + "static/media/download-file.a1c3a1f4.svg";